/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const modulesFormDataInputQuestionDataAttributeSchema = z.union([
	z.literal('name'),
	z.literal('email'),
	z.literal('phone'),
	z.literal('contact_consent'),
	z.literal('cv'),
	z.literal(null),
])

export type ModulesFormDataInputQuestionDataAttributeSchema = z.infer<
	typeof modulesFormDataInputQuestionDataAttributeSchema
>
